import { render, staticRenderFns } from "./RealmGuideTextMenu.vue?vue&type=template&id=7d12ed2a&"
import script from "./RealmGuideTextMenu.vue?vue&type=script&lang=js&"
export * from "./RealmGuideTextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports